import { ShieldCheck } from "lucide-react";
import { PACKAGES, IMAGES, waLink } from "../data/siteConfig";
import { useSEO } from "../components/SEO";
import FadeIn from "../components/FadeIn";
import FinalCTA from "../components/FinalCTA";

const PackagesPage = () => {
  useSEO(
    "Health Checkup Packages in Bhopal | Dr Lal PathLabs Collection Center",
    "Enquire about preventive health checkup packages in Bhopal — basic, complete, diabetes, thyroid, heart health and more."
  );

  return (
    <div>
      <section className="relative overflow-hidden bg-[#0B3056]">
        <img src={IMAGES.packages} alt="Happy family representing preventive health checkups" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">Preventive Health</p>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Health Checkup Packages
            </h1>
            <p className="mt-4 max-w-2xl text-base text-blue-100 md:text-lg">
              Ask about available preventive health checkups and diagnostic packages. Our team will share current
              package details, inclusions and prices on enquiry.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PACKAGES.map((p, i) => (
            <FadeIn key={p.name} delay={(i % 4) * 0.06} className="h-full">
              <article className="flex h-full flex-col rounded-2xl border border-gray-100 bg-white p-7 shadow-sm transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-lg" data-testid={`package-card-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#F0F7FA] text-[#1E88E5]">
                  <ShieldCheck size={22} aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-[#0B3056]">{p.name}</h2>
                <p className="mt-2 flex-1 text-sm text-slate-600">{p.desc}</p>
                <p className="mt-4 text-xs font-medium uppercase tracking-wide text-slate-500">Availability &amp; details — enquire now</p>
                <a
                  href={waLink(`Hello, I would like to enquire about the ${p.name} package at Dr Lal PathLabs Collection Center, Bhopal.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`package-enquire-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="mt-3 inline-flex min-h-[40px] items-center justify-center rounded-full border border-[#1E88E5] px-4 py-2 text-xs font-semibold text-[#1E88E5] transition-colors hover:bg-[#F0F7FA]"
                >
                  Enquire About Package
                </a>
              </article>
            </FadeIn>
          ))}
        </div>
        <FadeIn className="mt-10 rounded-2xl bg-[#F0F7FA] p-6">
          <p className="text-sm leading-relaxed text-slate-600">
            Package availability, inclusions and prices are confirmed by the collection center at the time of enquiry.
            No package details are final until confirmed by our team.
          </p>
        </FadeIn>
      </section>

      <FinalCTA heading="Want Package Details?" text="Contact our collection center for current health checkup packages, inclusions and prices." />
    </div>
  );
};

export default PackagesPage;
